import {css} from '@emotion/css';
import {fullfill} from '../../styles/default'

export function makeStyles() {
    return css`
        ${fullfill()}
        position: relative;
    `
}
